import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { HealthCondition } from 'utils/enums';

export interface GetDiagsResponse {
  RmiComment: string | null,
  RmiCompanyId: string,
  RmiDescription: string,
  RmiDiagCode10: string,
  RmiDiagDesc: string,
  RmiDocCount: number,
  RmiHccCode: string,
  RmiReportedBy1: string | null,
  RmiReportedBy2: string | null,
  RmiReportedBy3: string | null,
  RmiReportedDt1: string | null,
  RmiReportedDt2: string | null,
  RmiReportedDt3: string | null,
  RmiSeverityCode: HealthCondition,
  RmiStatusCode: string,
  RmiStatusDesc: string,
  RmiUid: number
}

export interface Diags {
  RmiComment: string | null,
  RmiCompanyId: string,
  RmiDescription: string,
  RmiDiagCode10: string,
  RmiDiagDesc: string,
  RmiDocCount: number,
  RmiHccCode: string,
  RmiReportedBy1: string | null,
  RmiReportedBy2: string | null,
  RmiReportedBy3: string | null,
  RmiReportedDt1: string | null,
  RmiReportedDt2: string | null,
  RmiReportedDt3: string | null,
  RmiSeverityCode: string,
  RmiStatusCode: string,
  RmiStatusDesc: string,
  RmiUid: number
}

export interface UpdateStatusAndCommentModal {
  Comment: null | string,
  SeverityCode: string,
  StatusCode: string,
  Uid: number,
  UserId: string
}

export const getDiags = (companyId: string, membMpiNo: string, measureYear: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_HCC_AND_DIAGS_REQUEST });

  return api.eligibility.hcc.getDiags(companyId, membMpiNo, measureYear)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_HCC_AND_DIAGS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_HCC_AND_DIAGS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDetails = (companyId: string, membMpi: string, hccCode: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_HCC_DETAILS_REQUEST });

  return api.eligibility.hcc.getDetails(companyId, membMpi, hccCode)
    .then((res: any) => {

      dispatch({
        type: types.GET_HCC_DETAILS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_HCC_DETAILS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateStatusAndComment = (model: UpdateStatusAndCommentModal) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityHCC.isUpdating) { return Promise.reject(); }

  dispatch({ type: types.UPDATE_HCC_STATUS_AND_COMMENT_REQUEST });

  return api.eligibility.hcc.updateStatusAndComment(model)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_HCC_STATUS_AND_COMMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_HCC_STATUS_AND_COMMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteHccDoc = (memberDocId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityHCC.isDeleting) { return Promise.reject(); }

  dispatch({ type: types.DELETE_HCC_DOC_REQUEST });

  return api.eligibility.hcc.delete(memberDocId)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_HCC_DOC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_HCC_DOC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};